import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { DataService } from '../data.service';

export interface PeriodicElement {
  action: string;
  processname: string;
  description: string;
  active: boolean;
  modifiedby: string;
}

@Component({
  selector: 'app-processes',
  templateUrl: './processes.component.html',
  styleUrls: ['./processes.component.scss']
})
export class ProcessesComponent implements OnInit {

  isLoading = false;
  isError = false;
  errorMessage = "";
  process:any;

  constructor(    private router: Router,
    private dataService: DataService,
    private route: ActivatedRoute,
    private fb: FormBuilder) { 

  }

  ngOnInit() {
    this.getActiveProcess();
  }

  displayedColumns: string[] = [
    "action",
    "processname",
    "description",
    "active",
    "modifiedby",
    "modifieddate",

  ];
  dataSource = "";

  newProcess(){
    this.router.navigateByUrl('home/process/new')
  }

  editApp(){

  }

  getActiveProcess() {
    return new Promise((resolve, reject) => {
      console.log("ProcessFields");

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(`${localStorage.getItem("crm_orgid")}.domain`),
        subdomain: localStorage.getItem(`${localStorage.getItem("crm_orgid")}.subdomain`),
        data: {
          process: {
            active: 'active',
          },
        },
      };
      console.log("postOption", postOption);
      this.isLoading = true;
      this.dataService.getActiveProcess(postOption).subscribe(
        (res) => {
          console.log("res", res);

          if (res.success == 1) {
            this.process = res.data.process;
            console.log("Doneeee****", this.process);
  
            if (this.process != null) {
              this.dataSource = this.process.map((item) => ({
                id: item.id,
                label: item.labelname,
                name: item.name,
                description: item.description,
                active: item.active,
                modifiedby: item.modifiedby,
                modifieddate: item.modifieddate,
                // type: item.actiontype,
                // content: item.content,
                // metalayoutid: item.metalayoutid,
              }));
            }
  
            this.isLoading = false;
          } else {
            console.log("Error while saving");
            this.isLoading = false;
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }

  delete(id: any) {
    // alert(id)
    const organizationid = localStorage.getItem("crm_orgid");
    const domain = localStorage.getItem(`${localStorage.getItem("crm_orgid")}.domain`);
    const subdomain=  localStorage.getItem(`${localStorage.getItem("crm_orgid")}.subdomain`);
    const confirmDelete = window.confirm("Are you sure you want to delete?");
    // alert(objectid)
    if (!confirmDelete) {
      return;
    }

    this.isLoading = true;
    this.dataService
      .deleteProcess(organizationid,domain,subdomain, id)
      .subscribe(
        (res) => {
          // alert('****res****' + JSON.stringify(res));
          console.log(res);
          if (res.success == 1) {
            window.location.reload();
            this.isLoading = false;
          } else {
            console.log("error in delete");
            this.isLoading = false;
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
        }
      );
  }

}
